export default __webpack_public_path__ + "static/media/Group.74497a94.svg";